import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import Header from "./content/header"
import api from "../../services/api"


class AddcursosAdmin extends Component {

  constructor(props) {
    super(props);
    this.state ={
      ico: null,
      banner:null,
      nome:null,
      idcategoria:null,
      preco:null,
      precoinscricao:null,
      duracaosemestre:null,
      duracaohora:null,
      mec:null,
      objetivo:null,
      mercadotrabalho:null,
      categorias:[],
      unidades:[],
      idunidade:"",
      btn:"Criar Curso",
      btndisable:""
    }
  }


  async componentDidMount(){
    this.loadcategorias();
    this.loadunidades();
  }
 
 
  async loadcategorias () {
    const response = await api.get("/categorias");
    this.setState({ categorias: response.data });
  }
 



  onChangeico = e => {
    let files = e.target.files || e.dataTransfer.files;
  if (!files.length)
  return;
  this.createImageico(files[0]);
  }
  onChangebanner = e => {

    console.log("submited img")
    let files = e.target.files || e.dataTransfer.files;
    if (!files.length)
          return;
    this.createImagebanner(files[0]);
  }



  createImageico(file) {
    let reader = new FileReader();
    reader.onload = (e) => {
      this.setState({
        ico: e.target.result
      })
    };
    reader.readAsDataURL(file);
  }

  createImagebanner(file) {
    let reader = new FileReader();
    reader.onload = (e) => {
      this.setState({
        banner: e.target.result
      })
    };
    reader.readAsDataURL(file);
  }







  onFormSubmit = async e =>{
    e.preventDefault() ;
    console.log("f");
    this.setState({ btndisable:true, btn:"Aguarde" });
    console.log(this.state)
    const {  ico,banner,nome,idcategoria,precoinscricao,preco,
      duracaohora,duracaosemestre,objetivo,mercadotrabalho, idunidade } = this.state;
      if (!nome || !idcategoria || !precoinscricao || !preco
        || !duracaohora || !duracaosemestre || !objetivo || !mercadotrabalho || !idunidade) {
          this.setState({ error: "Preencha os dados antes de criar!",
        success:null, btndisable:false, btn:"Criar Curso" });
      } else {
      const response = await api.post("/admin/cursos/add", { banner,nome,idcategoria,precoinscricao,preco,
        duracaohora,duracaosemestre,objetivo,mercadotrabalho, idunidade});
       
       
        if(response.data.id){
          this.setState({ btndisable:true, btn:"Aguarde"  });
          this.props.history.push("/admin/cursos");
        }else{
          this.setState({ btndisable:false, btn:"Criar Curso" });
        }

      }
  }

  async loadunidades () {
    const response = await api.post("/unidades");
    this.setState({ unidades: response.data });
  }

  render() {

    
    return (
      <React.Fragment>
          <Header />
        <div class="container col-lg-4 p-4">     

        <h4>Adicionar Curso</h4>     
        <form  onSubmit={this.onFormSubmit}>
        {this.state.error && <p>{this.state.error}</p>}
        {this.state.success && <p>{this.state.success}</p>}

                <div class="form-group">
                    <label for="exampleFormControlInput1">Nome</label>
                    <input type="text" class="form-control" required='true' onChange={e => this.setState({ nome: e.target.value })}  />
                </div>
                <div class="form-group">
                    <label for="exampleFormControlInput1">Categoria</label>
                    <select class="browser-default custom-select" onChange={e => this.setState({ idcategoria: e.target.value })} >
                    <option value="0">Selecione um valor</option>

                    {this.state.categorias.map(el => (
                      <option value={el.id}>{el.nome}</option>
                    ))}
                    </select>
                </div>

                <div class="form-group">
                    <label for="exampleFormControlInput1">Unidade</label>
                    <select class="browser-default custom-select" onChange={e => this.setState({ idunidade: e.target.value })} >
                    <option value="0">Selecione um valor</option>

                    {this.state.unidades.map(el => (
                      <option value={el.id}>{el.nome}</option>
                    ))}
                    </select>
                </div>


                <div class="form-group">
                    <label for="exampleFormControlInput1">Primeira Mensalidade</label>
                    <input type="text" class="form-control" required='true' onChange={e => this.setState({ precoinscricao: e.target.value })}  />
                </div>
                <div class="form-group">
                    <label for="exampleFormControlInput1">Preço Mensalidade</label>
                    <input type="text" class="form-control" required='true' onChange={e => this.setState({ preco: e.target.value })}  />
                </div>
                <div class="form-group">
                    <label for="exampleFormControlInput1">Duração Semestre</label>
                    <input type="text" class="form-control" required='true' onChange={e => this.setState({ duracaosemestre: e.target.value })}  />
                </div>
                <div class="form-group">
                    <label for="exampleFormControlInput1">Duração Horas</label>
                    <input type="text" class="form-control" required='true' onChange={e => this.setState({ duracaohora: e.target.value })}  />
                </div>
                <label for="exampleFormControlInput1">Objetivo</label>
                <div class="form-group">
                    
                    <textarea class="form-group col-xs-12" rows="5"  cols="53" 
                    onChange={e => this.setState({ objetivo: e.target.value })} ></textarea>
                </div>

                <label for="exampleFormControlInput1">Público Alvo</label>
                <div class="form-group">
                    
                    <textarea class="form-group col-xs-12" rows="5"  cols="53"
                    onChange={e => this.setState({ mercadotrabalho: e.target.value })}  ></textarea>
                </div>

            

      <br></br>
              <label for="exampleFormControlInput1">Banner Show</label>
                <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text" >Upload</span>
                </div>
                <div class="custom-file">
                  <input type="file" class="custom-file-input" onChange={this.onChangebanner}
                    aria-describedby="inputGroupFileAddon01" />
                  <label class="custom-file-label" for="inputGroupFile01">Escolher Arquivo</label>
                </div>
              </div>
              <br></br><br></br><br></br>




                <div class="form-group">
                    <button class="btn btn-primary mb-2" disabled={this.state.btndisable==true} >{this.state.btn}</button>
 {this.state.error && <p>{this.state.error}</p>}
        {this.state.success && <p>{this.state.success}</p>}
                </div>
        </form>
















    </div>
      </React.Fragment>
       
    );
  }
}

export default withRouter(AddcursosAdmin);


// WEBPACK FOOTER //
// ./src/pages/Admin/addcursos.js